import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "documentprintuioptions"
    }}>{`DocumentPrintUiOptions`}</h1>
    <p>{`Document print ui options`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPPRESS_PRINT_PROGRESS`}</strong>{` = 1936748659`}</p>
      <p parentName="blockquote">{`Do not show progress bar during printing.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPPRESS_PRINT_WARNINGS`}</strong>{` = 1936750450`}</p>
      <p parentName="blockquote">{`Do not show warning dialog during printing.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPPRESS_PRINT_DIALOG`}</strong>{` = 1936745575`}</p>
      <p parentName="blockquote">{`Do not show print dialog.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SUPPRESS_FILE_SAVE_DIALOG`}</strong>{` = 1936089444`}</p>
      <p parentName="blockquote">{`Do not show file save dialog during printing.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      